<template>
  <CbModal @close="$closeDialog">
    <div class="auth-dialog">
      <div class="wrapper">
        <div class="title">
          <img src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/title_authorize.png" alt="授权规则标题" />
        </div>
        <div class="content">
          <div class="scroll-area">
            <CbRichTextRender :act-id="actId" content-id="dc6b3ea8-ddc3-4010-9baf-5c4cf03883ca" />
            <div class="footer">
              <div class="btn-wrapper">
                <div class="btn" @click="toggleAuthStatus(0)">
                  <img src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/btn_disagree.png" alt="不同意" />
                </div>
                <div class="btn" @click="toggleAuthStatus(1)">
                  <img src="https://aliimg.changba.com/!/activity2023/come_sing_with_me/btn_agree.png" alt="同意" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CbModal>
</template>

<script>
import store from "../store/store.js";
import { getGlobalParams } from "@changba/funny";
import { actId } from "../config";
export default {
  name: "AuthDialog",
  data() {
    return {
      actId,
    };
  },
  methods: {
    async toggleAuthStatus(status) {
      const params = await getGlobalParams();
      store.commit("toggleAuthChecked", {
        status,
        userid: params.userId,
      });
      // 告诉外界结果
      this.$emit("auth", status);
      this.$closeDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-dialog {
  .wrapper {
    position: relative;
    .title {
      position: absolute;
      top: -38px;
      left: 0;
      text-align: center;
      width: 100%;
      z-index: 10;
      img {
        width: 370px;
        height: 75px;
      }
    }
    .content {
      font-size: 22px;
      color: #e1bfff;
      width: 625px;
      height: 810px;
      background: #7c23f1 linear-gradient(179deg, #4e0893 0%, #8d46f2 100%);
      border-radius: 16px;
      border: 3px solid #e1bfff;
      padding: 80px 50px 30px;
    }
    .scroll-area {
      height: 100%;
      overflow-y: scroll;
    }
    .auth-item {
      margin-bottom: 18px;
      .auth-title {
        font-size: 26px;
        line-height: 40px;
        font-weight: 600;
      }
      .auth-desc {
        line-height: 35px;
      }
    }
    .footer {
      margin-top: 30px;
      .btn-wrapper {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        .btn {
          width: 230px;
          height: 82px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
